<template>
  <div class="AnnouncementContentText">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AnnouncementContentText',
}
</script>

<style lang="scss">
.AnnouncementContentText {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  flex: 1 0 0;
  align-self: stretch;
}
</style>
